export default __webpack_public_path__ + "static/media/reset.68b947e1.svg";